import { Component } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';

export const INPUT_DROPDOWN_PORTAL_NAME = 'inputDropdown';

@Component
class InputDropdownPortalTarget extends TsxComponent<{}> {
  public render() {
    return (
      <portal-target name={INPUT_DROPDOWN_PORTAL_NAME} multiple>
      </portal-target>
    );
  }
}

export default InputDropdownPortalTarget;
